<div class="information-card__wrapper">
  <information-card>
    <ng-container header>
      <h1 class="information-card__heading">{{ headerText }}</h1>
      <div class="information-card__divider"></div>
    </ng-container>

    <ng-container body>
      <p class="information-card__body-text">
        If you need help,
        <button class="information-card__cta-text information-card__cta-text--passive" (click)="emailAdvisor()">
          contact your financial professional.
        </button>
      </p>
    </ng-container>

    <ng-container container>
      <p>
        <button class="button button--yellow button--primary" (click)="routeTo('account-center')">Exit</button>
      </p>
    </ng-container>
  </information-card>
</div>
